export default "__VITE_ASSET__b80769d8__"